import {marker as _} from '@biesbjerg/ngx-translate-extract-marker';

export interface User {
    id?: string;
    username?: string;
    accountName?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    createdTimestamp?: number;
    roles: Roles[];
    access: AccessRights[];
}

/**
 * ENCODING = move agent light
 * VALIDATION = move agent expert
 */
export enum Roles {
    BUSINESS_ADMIN = 'business_admin',
    ADMIN = 'admin',
    INTERNAL_CREDIT_COLLECTION_EXPERT = 'internal_credit_collection_expert',
    INTERNAL_BACKOFFICE_EXPERT = 'internal_backoffice_expert',
    INTERNAL_BACKOFFICE_LIGHT = 'internal_backoffice_light',
    NURSING_AGENT_EXPERT = 'nursing_agent_expert',
    NURSING_AGENT_LIGHT = 'nursing_agent_light',
    SALES_AGENT_LIGHT = 'sales_agent_light',
    PARTNER_BACKOFFICE_LIGHT = 'partner_backoffice_light',
    VIEWER_AGENT_LIGHT = 'viewer_agent_light',
    ENCODING = 'encoding',
    VALIDATION = 'validation'
}

_('userProfile.roles.admin');
_('userProfile.roles.businessAdmin');
_('userProfile.roles.internalCreditCollectionExpert');
_('userProfile.roles.internalBackofficeExpert');
_('userProfile.roles.nursingAgentExpert');
_('userProfile.roles.nursingAgentLight');
_('userProfile.roles.salesAgentLight');
_('userProfile.roles.partnerBackofficeLight');
_('userProfile.roles.viewerAgentLight');

export enum AccessRights {
    REPORTING = 'reporting',
    VIEW_REGISTRATION_OVERVIEW = 'view_registration_overview',
    DELREG_CREATE = 'delreg_create',
    DELREG_VIEW = 'delreg_view',
    DELREG_EDIT = 'delreg_edit',
    DELREG_SIGN_PAPER = 'delreg_sign_paper',
    DELREG_SEND_SIGNATURE = 'delreg_send_signature',
    DELREG_SEND_OFFER = 'delreg_send_offer',
    DELREG_RESEND_OFFER = 'delreg_resend_offer',
    DELREG_ARCHIVE = 'delreg_archive',
    DELREG_POSTPONE = 'delreg_postpone',
    VIEW_WORKLIST_OVERVIEW = 'view_worklist_overview',
    VIEW_BUYING_GROUP = 'view_buying_group',
    VIEW_DOCUMENTS_TEMPLATE_MANAGER = 'view_documents_template_manager',
    VIEW_PIPELINE_DATA = 'view_pipeline_data',
    REGVAL_VIEW = 'regval_view',
    REGVAL_EDIT = 'regval_edit',
    REGVAL_ARCHIVE = 'regval_archive',
    REGVAL_RETRY = 'regval_retry',
	REGVAL_FORCE = 'regval_force',
	// everyone with view can retry in validation mode. only this right can retry when activation failed
	REGVAL_RETRY_ACTIVATION = 'regval_retry_activation',
	REGVAL_UNARCHIVE = 'regval_unarchive',
	REGVAL_CHANGE_STATUS_ACTIVATION_FAILED = 'regval_change_status_activation_failed',
	REGVAL_VALIDATION_CONTROL = 'regval_validation_control',
	REGVAL_CHECKFRAUD_UNJUSTIFIED = 'regval_checkfraud_unjustified',
	REGVAL_SCREENING_UNJUSTIFIED = 'regval_screening_unjustified',
	RENEWAL_VIEW = 'renewal_view',

    MOVE_VIEW = 'move_view',
    MOVE_CREATE = 'move_create',
    MOVE_SAVE = 'move_save',
    MOVE_UNARCHIVE = 'move_unarchive',
    MOVE_UPDATE = 'move_update',
    MOVE_ASSIGN = 'move_assign',
    MOVE_WORKING_LIST = 'move_working_list',

    SIMULATION_CREATE = 'simulation_create',
    SIMULATION_VIEW = 'simulation_view',
    SIMULATION_REPORTING = 'simulation_reporting',
    SIMULATION_PROMO_ASSIGN = 'simulation_promo_assign',

	PRODUCT_SERVICES_VIEW = 'product_services_view',
	PRODUCT_SERVICES_CREATE = 'product_services_create'
}
